(function(){
  // 1. STICKY ATC: Cambia texto a Comprar ahora
  var obs=new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes.forEach(function(node){
        if(node.nodeType!==1)return;
        var list=[];
        if(node.classList&&node.classList.contains('t4s-sticky-atc__atc')){
          var sp=node.querySelector('.t4s-btn-atc_text');
          if(sp)list.push(sp);
        } else if(node.querySelectorAll){
          node.querySelectorAll('.t4s-sticky-atc__atc .t4s-btn-atc_text').forEach(function(sp){list.push(sp);});
        }
        list.forEach(function(sp){
          var t=sp.textContent.trim();
          if(t!=='Agotado'&&t!=='Preorden')sp.textContent='Comprar ahora';
        });
      });
    });
  });
  obs.observe(document.documentElement,{childList:true,subtree:true});

  // 2. STICKY ATC: Click -> directo a checkout
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.t4s-sticky-atc__atc');
    if(!btn)return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var variantId=btn.getAttribute('data-variant-id');
    if(!variantId)return;
    var stickyBar=btn.closest('[data-sticky-addtocart]');
    var qty=1;
    if(stickyBar){
      var inp=stickyBar.querySelector('input[type="number"],input[name="quantity"]');
      if(inp)qty=parseInt(inp.value)||1;
    }
    btn.disabled=true;
    btn.classList.add('is--loading');
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:parseInt(variantId),quantity:qty})
    }).then(function(r){
      if(r.ok){window.location.href='/checkout';}
      else{btn.disabled=false;btn.classList.remove('is--loading');}
    }).catch(function(){btn.disabled=false;btn.classList.remove('is--loading');});
  },true);

  // 3. URGENCY MESSAGE
  function addUrgencyMsg(){
    if(document.querySelector('.xhantae-urgency'))return;
    var btn=document.querySelector('[data-atc-form]');
    if(!btn)return;
    var container=btn.closest('.t4s-product-form__buttons')||btn.parentElement;
    var msg=document.createElement('p');
    msg.className='xhantae-urgency';
    msg.textContent='🧵 Producción artesanal · Hecho a mano en Oaxaca — Pocas piezas disponibles';
    msg.style.cssText='font-size:13px;color:#8B5E3C;margin-top:10px;font-style:italic;line-height:1.4;';
    container.parentElement.insertBefore(msg,container.nextSibling);
  }

  // 4. GUIA DE TALLAS (solo productos tipo Calzado)
  function addSizeGuide(){
    if(document.querySelector('.xhantae-size-guide'))return;
    var pt=window.xhantaePT||'';
    if(pt.toLowerCase().indexOf('calzado')===-1)return;
    var anchor=document.querySelector('.t4s-product-form__buttons');
    if(!anchor)return;
    var guide=document.createElement('div');
    guide.className='xhantae-size-guide';
    guide.style.cssText='margin:14px 0;border:1px solid #e8d5c4;border-radius:6px;overflow:hidden;';
    guide.innerHTML='<details><summary style="cursor:pointer;padding:10px 14px;font-size:13px;font-weight:600;color:#5a3e28;background:#fdf6f0;list-style:none;display:flex;align-items:center;gap:6px;">📏 Guía de tallas — ¿Cuál es la mía?</summary><div style="padding:12px 14px;background:#fff;"><p style="font-size:12px;color:#888;margin:0 0 10px;">Mide la longitud de tu pie con calcetín puesto, de talón al dedo más largo.</p><table style="width:100%;border-collapse:collapse;font-size:12px;text-align:center;"><thead><tr style="background:#fdf6f0;"><th style="padding:6px 4px;border-bottom:1px solid #e8d5c4;color:#5a3e28;">MX</th><th style="padding:6px 4px;border-bottom:1px solid #e8d5c4;color:#5a3e28;">Pie (cm)</th><th style="padding:6px 4px;border-bottom:1px solid #e8d5c4;color:#5a3e28;">US</th><th style="padding:6px 4px;border-bottom:1px solid #e8d5c4;color:#5a3e28;">EU</th></tr></thead><tbody><tr><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">23</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">23 cm</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">6</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">36</td></tr><tr><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">23.5</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">23.5 cm</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">6.5</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">36.5</td></tr><tr><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">24</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">24 cm</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">7</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">37</td></tr><tr><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">24.5</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">24.5 cm</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">7.5</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">37.5</td></tr><tr><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">25</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">25 cm</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">8</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">38</td></tr><tr><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">25.5</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">25.5 cm</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">8.5</td><td style="padding:5px 4px;border-bottom:1px solid #f0e6dc;">38.5</td></tr><tr><td style="padding:5px 4px;">26</td><td style="padding:5px 4px;">26 cm</td><td style="padding:5px 4px;">9</td><td style="padding:5px 4px;">39</td></tr></tbody></table></div></details>';
    anchor.parentElement.insertBefore(guide,anchor);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){
      setTimeout(addUrgencyMsg,600);
      setTimeout(addSizeGuide,600);
    });
  } else {
    setTimeout(addUrgencyMsg,600);
    setTimeout(addSizeGuide,600);
  }
})();